//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { NavCanvas } from "./nav-canvas";
export default {
  data: function data() {
    return {
      nc: null,
      navs: [{
        icon: 'el-icon-menu',
        name: '大屏管理'
      }, {
        icon: 'el-icon-location-information',
        name: '地图管理'
      }, // {
      //      icon: 'el-icon-folder-opened',
      //      name: '分类管理'
      //    }, 
      {
        icon: 'el-icon-set-up',
        name: '数据源管理'
      } // {
      //      icon: 'el-icon-thumb',
      //      name: '综合功能'
      //    },
      ],
      activeNav: null,
      activeIndex: 0
    };
  },
  mounted: function mounted() {
    this.activeNav = this.navs[0];
    this.nc = new NavCanvas("nav-canvas", ".nav-main .nav-span", this.activeIndex);
  },
  methods: {
    toggleNav: function toggleNav(nav, index) {
      this.activeNav = nav;
      this.activeIndex = index;
      this.nc.toggle(this.activeIndex);
      this.$emit('change', nav, index);
    }
  }
};